import script from "./CasesNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./CasesNavigation.vue?vue&type=script&setup=true&lang=js"

import "./CasesNavigation.vue?vue&type=style&index=0&id=64cdb093&lang=scss"

const __exports__ = script;

export default __exports__